import { TransferStatus } from '../../typing';
import { parseDomain } from '../../utils';
import { CheckTransferInStatus } from '@wix/ambassador-domain-delivery/types';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { Specs } from '../../constants/Specs';
export const canTransferInDomain = async _ref => {
  let {
    httpClient,
    request: {
      domain
    }
  } = _ref;
  const {
    experiments
  } = getPremiumEssentialsSafe() ?? {};
  const isBlockTransferGateEnabled = experiments == null ? void 0 : experiments[Specs.BLOCK_TRANSFER_GATE];
  if (!domain) {
    return {
      canTransferIn: false
    };
  }
  const parsedDomain = domain.main ? domain : parseDomain(domain);
  const {
    checkDomainIsTaken,
    listTransferIns,
    checkTransferInStatus
  } = await dynamicLoadApiQueries(httpClient);
  const {
    isAvailable
  } = await checkDomainIsTaken({
    domain: parsedDomain.asciiDomain
  });
  if (isAvailable) {
    return {
      canTransferIn: false
    };
  }
  const [{
    transfers
  }, {
    status
  }] = await Promise.all([listTransferIns({}), checkTransferInStatus({
    domainName: parsedDomain.asciiDomain
  })]);
  const transferInRequest = transfers == null ? void 0 : transfers.find(transfer => transfer.domainName === parsedDomain.asciiDomain);
  const transferInStatusValidation = TransferStatus.COMPLETED !== (transferInRequest == null ? void 0 : transferInRequest.transferStatus) && TransferStatus.PENDING !== (transferInRequest == null ? void 0 : transferInRequest.transferStatus);
  const supportedTransferInStatuses = isBlockTransferGateEnabled ? [CheckTransferInStatus.OK] : [CheckTransferInStatus.DOMAIN_LOCKED, CheckTransferInStatus.OK];
  const canTransferIn = supportedTransferInStatuses.includes(status ?? CheckTransferInStatus.TRANSFER_NOT_ALLOWED) && transferInStatusValidation;
  const blockByTransferInStatus = status !== CheckTransferInStatus.OK ? status : !transferInStatusValidation ? transferInRequest.transferStatus : undefined;
  return {
    canTransferIn,
    status: blockByTransferInStatus,
    error: status === CheckTransferInStatus.DOMAIN_LOCKED ? 'lockedByProvider' : undefined
  };
};
//# sourceMappingURL=canTransferInDomain.js.map